import { RootState } from '../../../types.ts';

export const selectAlerts = (state: RootState) => state.alerts;
